import { render, staticRenderFns } from "./AdminePreview.vue?vue&type=template&id=cb0c4de4&scoped=true"
import script from "./AdminePreview.vue?vue&type=script&lang=js"
export * from "./AdminePreview.vue?vue&type=script&lang=js"
import style0 from "./AdminePreview.vue?vue&type=style&index=0&id=cb0c4de4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0c4de4",
  null
  
)

export default component.exports